<template>
  <span>{{text}}</span>
</template>

<script>
export default {
  name: "TimeDifference",
  props: {
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    }
  },
  data(){
    return {
      text: '-'
    }
  },
  mounted(){
    this.calculate()
  },
  beforeDestroy() {},
  methods: {
    calculate(){
      const vm = this
      const diff = vm.$moment(vm.end).diff(vm.$moment(vm.start))
      const duration = vm.$moment.duration(diff)
      let humanized

      if(duration.hours() === 0 && duration.minutes() === 0) {
        vm.text = `menos de 1 minuto`
        return
      }

      let hours = duration.hours()
      const hoursLabel = `hora${hours > 1 ? 's' : ''}`

      let minutes = duration.minutes()
      const minutesLabel = `minuto${minutes > 1 ? 's' : ''}`

      let hoursForHumans = hours > 0 ? `${hours} ${hoursLabel}` : ''
      let minutesForHumans =  minutes > 0 ? `${minutes} ${minutesLabel}` : ''

      if(hoursForHumans && minutesForHumans){
        humanized =  `${hoursForHumans} y ${minutesForHumans}`
      }else{
        humanized = hoursForHumans ? `${hoursForHumans}` : `${minutesForHumans}`
      }

      vm.text = `${humanized}`
    }
  }
}
</script>

<style scoped>

</style>
